(function () {
  var section  = document.getElementById('stats-section');
  if (!section) return;

  var counters = section.querySelectorAll('.counter');
  var animated = false;

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function animateCounters() {
    if (animated) return;
    animated = true;

    var DURATION = 1400;
    var start    = performance.now();

    (function tick(now) {
      var progress = Math.min((now - start) / DURATION, 1);
      var eased    = easeOutCubic(progress);

      counters.forEach(function (el) {
        var target = parseInt(el.dataset.target, 10);
        el.textContent = Math.floor(eased * target).toLocaleString();
      });

      if (progress < 1) {
        requestAnimationFrame(tick);
      } else {
        counters.forEach(function (el) {
          el.textContent = parseInt(el.dataset.target, 10).toLocaleString();
        });
      }
    })(start);
  }

  /* Trigger fade-in + counter when section enters viewport */
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        section.classList.add('visible');
        animateCounters();
        observer.unobserve(section);
      });
    },
    { threshold: 0.2 }
  );

  observer.observe(section);
})();
